<template>
  <b-overlay :show="loading">
    <vs-row
        :class="{ selected: file.id === actualBilling.id }"
        class="p-3 mt-2 shadow-sm bg-white"
    >
      <vs-col vs-lg="11">
        <vs-row>
          <vs-col
              vs-lg="2"
              data-cy="file-status"
          >
            <div data-cy="file-receptor">
              {{ file.receptor.razonSocial }} <br/> {{ file.receptor.iut }}
            </div>
          </vs-col>
          <vs-col vs-lg="8">
            <vs-row>
              <vs-col
                  vs-lg="3"
                  vs-sm="3"
                  vs-xs="12"
              >
                {{ file.detalle.monto | amount }}
              </vs-col>
              <vs-col
                  vs-lg="3"
                  vs-sm="3"
                  vs-xs="12"
              >
                {{ file.detalle.moneda }}
              </vs-col>
              <vs-col
                  vs-lg="6"
                  vs-sm="3"
                  vs-xs="12"
                  v-html="detalle"
              >
              </vs-col>
            </vs-row>
          </vs-col>
        </vs-row>
        <RowLargeBilling
            v-if="screenSizeFull"
            :file="file"
        />
        <RowSmallBilling
            v-if="!screenSizeFull"
            :file="file"
        />
      </vs-col>
      <vs-col
          vs-lg="1"
          vs-type="flex"
          vs-justify="center"
          vs-align="center"
      >
        <slot
            name="actions"
            v-bind:file="file"
        >
          <BillingOptions
              :ref="'file-options-' + file.id"
              :file="file"
          />
        </slot>
      </vs-col>
    </vs-row>
  </b-overlay>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import CopyToClipboard from '@/febos/chile/approvals/mixins/CopyToClipboard';
import RowSmallBilling from '@/febos/global/billing/components/RowSmallBilling';
import RowLargeBilling from '@/febos/global/billing/components/RowLargeBilling';
import BillingOptions from '@/febos/global/billing/components/BillingOptions';
import tags from '@/febos/global/billing/settings/PreDefinedTagsTemplates';

export default {
  components: { BillingOptions, RowSmallBilling, RowLargeBilling },
  mixins: [CopyToClipboard],
  data() {
    return {
      loading: false
    };
  },
  props: [
    'file'
  ],
  computed: {
    ...mapGetters('Dnts', ['selectedFile']),
    ...mapGetters('Usuario', ['currentUserId']),
    ...mapGetters('Empresas', ['company']),
    ...mapGetters('Billing', ['actualBilling']),
    screenSizeFull() {
      return window.innerWidth > 1024;
    },
    detalle() {
      let current = this.file.detalle.descripcion;
      const numCuota = this.file.emisor.numCuota || 1;
      const numCuotas = this.file.emisor.numCuotas || 10;
      tags.forEach((tag) => {
        if (tag.value === '{{cuota}}') {
          const st = `<span class="tag" title="${tag.label}" v-tooltip="'${tag.label}'">${numCuota}</span>`;
          current = this.replaceAll(current, tag.value, st);
        } else if (tag.value === '{{cuotas}}') {
          const st = `<span class="tag" title="${tag.label}" v-tooltip="'${tag.label}'">${numCuotas}</span>`;
          current = this.replaceAll(current, tag.value, st);
        } else if (tag.label) {
          const st = `<span class="tag" title="${tag.label}" v-tooltip="'${tag.label}'">${tag.example}</span>`;
          current = this.replaceAll(current, tag.value, st);
        } else {
          const st = `<span class="tag">${tag}</span>`;
          current = this.replaceAll(current, tag, st);
        }
      });
      return current;
    }
  },
  methods: {
    ...mapActions('Modals', [
      'showModals'
    ]),
    ...mapActions('Approvals', [
      'getApprovalFileDetails',
      'getAttachmentFiles',
      'getFileBinnacle',
      'getApprovalManagedFile'
    ]),
    replaceAll(str, term, replacement) {
      return str.replace(new RegExp(this.escapeRegExp(term), 'g'), replacement);
    },
    escapeRegExp(str) {
      return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    async getFlowDetails() {
      if (this.isAguasAndinas) {
        return;
      }
      this.selectFile(this.file);
      this.loading = true;
      try {
        await Promise.all([
          this.getApprovalFileDetails({
            aprobacionId: 0,
            ejecucionId: this.file.aprobacionId
          }),
          this.getAttachmentFiles({
            aprobacionId: 0,
            ejecucionId: this.file.aprobacionId
          }),
          this.getFileBinnacle({
            documentoId: this.file.aprobacionId
          })
        ]);
      } catch (error) {
        console.error(error);
      }
      this.loading = false;
      await this.showModals('flowFile');
    }
  }
};

</script>
<style>
.selected {
  background: rgba(var(--vs-primary), 0.1) !important;
}

.mother-indicator {
  width: 160px;
  margin-left: 50%;
  left: 80px;
}

.tag {
  background-color: var(--gray) !important;
  font-weight: bold;
  border-radius: 5px;
  margin: 2px;
  padding: 3px;
}
</style>
